// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2SM5w","inner":"Form_inner__1yqSp","range":"Form_range__2MEJI","name":"Form_name__2O2i8","actions":"Form_actions__2wsIo"};